export default __webpack_public_path__ + "static/media/visa-single.9c4e952e.svg";